import Layout from 'antd/es/layout';
import styled, { css } from 'styled-components';
import { getAppTheme } from '../navigation/styles';
import { UserMenuButtonStyled } from './components/user-menu/styles';
const { Header } = Layout;
export const GeneralLayout = styled(Layout) `
  min-height: 100%;
  height: ${({ $naturalScroll }) => ($naturalScroll ? 'auto' : '100%')};
  overflow: ${({ $naturalScroll }) => ($naturalScroll ? 'visible' : 'hidden')};
  display: flex;
  flex-direction: column;
  &.ant-layout {
    font-family: Inter, sans-serif;
  }
`;
export const AppLayoutContentContainer = styled(Layout) `
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1 1 auto;
  min-height: ${({ $naturalScroll }) => ($naturalScroll ? '100vh' : 0)};
  height: ${({ $naturalScroll }) => ($naturalScroll ? 'auto' : '100%')};
  overflow: ${({ $naturalScroll }) => ($naturalScroll ? 'visible' : 'hidden')};
  &.ant-layout {
    font-family: Inter, sans-serif;
  }
`;
export const getAppStyling = (theme) => {
    const appTheme = getAppTheme(theme);
    return css `
    background-color: ${appTheme.headerBgColor};
    color: ${appTheme.headerTextColor};

    ${UserMenuButtonStyled} {
      color: ${appTheme.headerTextColor};
    }
  `;
};
export const AppHeaderContainer = styled(Header) `
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.lg};
  align-items: center;
  justify-content: space-between;
  padding-inline: 24px;
  padding-block: 1px;
  height: 44px;
  position: relative;
  ${({ theme }) => getAppStyling(theme)}
`;
export const AppHeaderContent = styled.div `
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.lg}px;
`;
export const AppHeaderBreadcrumbSlot = styled.div `
  flex: 1 1 auto;
  min-width: 0;
`;
export const AppHeaderUtilities = styled.div `
  display: flex;
  flex: 0 1 auto;
  min-width: 0;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md}px;
`;
export const AppHeaderBreadcrumbContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-inline: 20px;
  padding-block: 1px;
  background-color: ${({ theme }) => theme.colors.white_1};
`;
export const AppHeaderWrapper = styled.div `
  width: 100%;
  position: sticky;
  z-index: 200;
  width: 100%;
  top: 0;
  transition: left 200ms linear;
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
`;
